import { NG_VALIDATORS } from '@angular/forms';
import { alphanum } from './alphanum.validator';
import { bic, iban } from './iban.validator';
import { phone } from './phone.validator';
import { requireOne } from './require-one.validator';
import { requireTrue } from './require-true.validator';

export const GsmValidators = {
  alphanum,
  iban,
  bic,
  phone,
  requireOne,
  requireTrue
};

export const GSM_VALIDATOR_PROVIDERS = [
  {provide:   NG_VALIDATORS,
    useValue: requireOne,
    multi:    true
  },
  {provide:   NG_VALIDATORS,
    useValue: requireTrue,
    multi:    true
  },
  {provide:   NG_VALIDATORS,
    useValue: iban,
    multi:    true
  },
  {provide:   NG_VALIDATORS,
    useValue: bic,
    multi:    true
  },
  {provide:   NG_VALIDATORS,
    useValue: alphanum,
    multi:    true
  },
  {provide:   NG_VALIDATORS,
    useValue: phone,
    multi:    true
  }
];
